module.exports = __webpack_public_path__ + "img/daylight_0.7132e76b.png";